import loaders from './loaders';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import StaticNavigation from '../../components/StaticNavigation';
import SideNavigation from '../../components/SideNavigation';
import Category from '../../components/Category';
import RecentlyPlayed from '../../components/Category';
import BingoGames from '../../components/BingoGames';
import GameDetails from '../../components/GameDetails';
import SearchCategory from '../../components/SearchCategory';
import ContentWrapper from '../../components/ContentWrapper';
import BottomNavigation from '../../components/BottomNavigation';
import SearchInput from '../../components/SearchInput';
import SearchBar from '../../components/SearchBar';
import SimplifiedHeader from '../../components/SimplifiedHeader';
import Modal from '../../components/Modal';
import PromotionsBasecamp from '../../components/PromotionsBasecamp';
import CopyParagraph from '../../components/CopyParagraph';
import Steps from '../../components/Steps';

const GameDetailsHeader = loaders.lazy(() =>
  import(
    /* webpackChunkName: "GameDetailsHeader" */ '../../components/GameDetailsHeader'
  )
);
const SearchMoreResults = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchMoreResults" */ '../../components/Category'
  )
);
const Footer = loaders.lazy(() =>
  import(/* webpackChunkName: "Footer" */ '../../components/Footer')
);
const SearchHeader = loaders.lazy(() =>
  import(/* webpackChunkName: "SearchHeader" */ '../../components/SearchHeader')
);
const SearchHistory = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchHistory" */ '../../components/SearchHistory'
  )
);
const ErrorPage = loaders.lazy(() =>
  import(/* webpackChunkName: "ErrorPage" */ '../../components/ErrorPage')
);
const GameModal = loaders.lazy(() =>
  import(/* webpackChunkName: "GameModal" */ '../../components/GameModal')
);
const Copy = loaders.lazy(() =>
  import(/* webpackChunkName: "Copy" */ '../../components/Copy')
);
const ErrorContainer = loaders.lazy(() =>
  import(
    /* webpackChunkName: "ErrorContainer" */ '../../components/ErrorContainer'
  )
);
const CookieBanner = loaders.lazy(() =>
  import(/* webpackChunkName: "CookieBanner" */ '../../components/CookieBanner')
);
const Menu = loaders.lazy(() =>
  import(/* webpackChunkName: "Menu" */ '../../components/Menu')
);
const SearchWrapper = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchWrapper" */ '../../components/SearchWrapper'
  )
);
const Download = loaders.lazy(() =>
  import(/* webpackChunkName: "Download" */ '../../components/DownloadPage')
);
const SearchSuggestions = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchSuggestions" */ '../../components/SearchSuggestions'
  )
);

const DynamicRouteAction = loaders.lazy(() =>
  import(
    /* webpackChunkName: "DynamicRouteAction" */ '../../components/DynamicRouteAction'
  )
);

const componentMapping = {
  Layout,
  Header,
  StaticNavigation,
  SideNavigation,
  Category,
  RecentlyPlayed,
  GameDetails,
  SearchCategory,
  ContentWrapper,
  BottomNavigation,
  SearchInput,
  SearchBar,
  SimplifiedHeader,
  Modal,
  PromotionsBasecamp,
  CopyParagraph,
  DynamicRouteAction,
  GameDetailsHeader,
  SearchMoreResults,
  Footer,
  SearchHeader,
  SearchHistory,
  ErrorPage,
  GameModal,
  Copy,
  ErrorContainer,
  CookieBanner,
  Steps,
  Menu,
  SearchWrapper,
  Download,
  SearchSuggestions,
  BingoGames,
};

export default componentMapping;
